import React, { useEffect, useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import Classes from "../Profile.module.css";
import MenteeLevelDropDown from "./DropDowns/MenteeLevelDropDown";
import LanguagesDropDown from "./DropDowns/LanguagesDropDown";
import AvailabilityDropDown from "./DropDowns/AvailabilityDropDown";

export default function SessionDetails({ initial = {}, saveProfile, onNext, onBack }) {
  const [form, setForm] = useState({
    expectSession: "",
    menteeLevel: [],
    languagesSpoken: [],
    availability: [],
  });
  const [saving, setSaving] = useState(false);

  // ⬇️ sync with `initial`
  useEffect(() => {
    setForm({
      expectSession: initial.expectSession ?? "",
      menteeLevel: initial.menteeLevel ?? [],
      languagesSpoken: initial.languagesSpoken ?? [],
      availability: initial.availability ?? [],
    });
  }, [initial]);

  const setArr = (k) => (val) => setForm((p) => ({ ...p, [k]: val }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    await saveProfile({ sessionDetails: form });
    setSaving(false);
    onNext();
  };

  return (
    <>
      <Backdrop open={saving} sx={{ zIndex: 1301, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <form className={Classes.infoCon} onSubmit={submit}>
        <div className={Classes.infoConMiddle}>
          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>What Can Mentees Expect From a Session With You?</h5>
              <input
                name="expectSession"
                className={Classes.inputField}
                placeholder="Provide a short answer"
                value={form.expectSession}
                onChange={(e) => setForm((p) => ({ ...p, expectSession: e.target.value }))}
                required
              />
            </div>
          </div>

          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Preferred Mentee Level</h5>
              <MenteeLevelDropDown selected={form.menteeLevel} onChange={setArr("menteeLevel")} />
            </div>
          </div>

          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Languages Spoken</h5>
              <LanguagesDropDown selected={form.languagesSpoken} onChange={setArr("languagesSpoken")} />
            </div>
          </div>

          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Availability</h5>
              <AvailabilityDropDown selected={form.availability} onChange={setArr("availability")} />
            </div>
          </div>
         
        </div>

        <button type="submit" className={Classes.saveBtn}><h5>Next</h5></button>
      </form>
    </>
  );
}
